/**
 * All available query params across app routes.
 */

export enum AppRouteQueryParam {
  GsOutletId = 'gsOutletId',
  AllGsOutletIds = 'allGsOutletIds',
  DealerGroup = 'dealerGroup',
  CompanyId = 'companyId'
}

export const appRouteQueryParams: string[] = [
  AppRouteQueryParam.GsOutletId,
  AppRouteQueryParam.AllGsOutletIds,
  AppRouteQueryParam.DealerGroup,
  AppRouteQueryParam.CompanyId
];
